export class ApiError extends Error {
  constructor(public status: number, public code: string, message: string, public details?: unknown) {
    super(message);
  }
}

export async function api<T = any>(path: string, opts: { method?: string; body?: unknown } = {}): Promise<T> {
  const method = opts.method ?? 'GET';
  // POST sem payload envia {} (o servidor recusa content-type JSON com corpo vazio).
  const res = await fetch(path, {
    method,
    credentials: 'same-origin',
    headers: { 'content-type': 'application/json', 'x-requested-with': 'mcc' },
    body: method === 'GET' ? undefined : JSON.stringify(opts.body ?? {}),
  });
  const text = await res.text();
  const data = text ? JSON.parse(text) : null;
  if (!res.ok) throw new ApiError(res.status, data?.error ?? 'ERROR', data?.message ?? `Erro ${res.status}`, data?.details);
  return data as T;
}

export const fmtDate = (v: string | Date | null | undefined, withTime = true) =>
  v
    ? new Intl.DateTimeFormat('pt-BR', { timeZone: 'America/Sao_Paulo', dateStyle: 'short', ...(withTime ? { timeStyle: 'short' } : {}) }).format(new Date(v))
    : '—';

export const fmtUsd = (v: number | null | undefined) => (v === null || v === undefined ? '—' : `US$ ${Number(v).toFixed(4)}`);
